import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SliderFormPage } from './slider-form.page';

const routes: Routes = [
  {
    path: '',
    component: SliderFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SliderFormPageRoutingModule {}
